(function(){
    "use strict";
    
    angular
        .module("app")
        .component("bundleSuggest", { // bundle-suggest
            bindings: {
                incentiveId:"<"
            },
            templateUrl: "src/app/_shared/bundleSuggest/bundleSuggest.html",
            controller: controller
        });

    function controller(session) {
        const $ctrl = this;
        
        $ctrl.$onInit = () => {

        };

        $ctrl.getItems = () => {
            const incentive = session.incentives.find(i => i.incentive_id === $ctrl.incentiveId);
            if (!incentive)
                return [];
            return session.allProducts.filter(p => incentive.items.some(i => i.item_id === p.item_id));
        };
    }
    controller.$inject = ["sessionService"];
    
})()